module.exports = __webpack_public_path__ + "img/bg1 (2).849aeea9.jpg";